export const toSubscriptionDetails = (productId: string, subscriptionId: string) =>
	`/Products/${productId}/Subscriptions/${subscriptionId}`;

export const toFeatureToggleDetails = (productId: string, featureToggleId: string) =>
	`/Products/${productId}/FeatureToggles/${featureToggleId}`;

export const toOperationalConfigurationDetail = (productId: string, operationalConfigurationId: string) =>
	`/Products/${productId}/OperationalConfigurations/${operationalConfigurationId}`;

export const toReportDetails = (productId: string, reportId: string) => `/Products/${productId}/Reports/${reportId}`;

export const toReportList = (productId: string) => `/Products/${productId}/Reports`;

export const toUserListPage = () => `/Administration/Users`;

export const toUserEditPage = (userPrincipalName: string) => `/Administration/Users/${userPrincipalName}`;

export const toServiceMessagingPage = () => `/Administration/ServiceMessaging`;

export const toTwilioInvoiceListPage = (productId: string) => `/Products/${productId}/Invoices`;

export const toTwilioInvoiceDetailsPage = (productId: string, twilioInvoiceDate: string) =>
	`/Products/${productId}/Invoices/${twilioInvoiceDate}`;

export const toCLELoggerTestingPage = () => `/Administration/CLELogger`;

export const toTestReportsPage = () => `/Administration/TestReports`;

export const toServiceLogLevelPage = () => `/Administration/ServiceLogLevel`;
